module.exports = __webpack_public_path__ + "img/sqym.cc488655.png";